import { render, staticRenderFns } from "./HeavyIcon.vue?vue&type=template&id=3be400b6"
import script from "./HeavyIcon.vue?vue&type=script&lang=js"
export * from "./HeavyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports